import { render, staticRenderFns } from "./FollowPeriodPad.vue?vue&type=template&id=2bc857f7&scoped=true"
import script from "./FollowPeriodPad.vue?vue&type=script&lang=js"
export * from "./FollowPeriodPad.vue?vue&type=script&lang=js"
import style0 from "./FollowPeriodPad.vue?vue&type=style&index=0&id=2bc857f7&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bc857f7",
  null
  
)

export default component.exports